import React, { useState } from "react";
import minimarket from '../../assets/images/minimarket.webp';
import iconWhatsapp from '../../assets/images/icon-whatsapp.webp';
import iconbrios from '../../assets/images/logo192.png';

const ListResult = (props) => {

    const [expandedItems, setExpandedItems] = useState({});
    const listaOrdenada = props.listItems.sort(function (a, b) { return a.dist - b.dist });

    const handleToggle = (index) => {
        setExpandedItems((prevState) => ({
            ...prevState,
            [index]: !prevState[index]
        }));
    };

    const list = listaOrdenada.map((data, i) => {
        const isExpanded = !!expandedItems[i];

        if (data.name === 'Brios') {
            return (<li key={i} className="row border-bottom py-3">
                <div className="col-sm-12 col-md-12 col-lg-2 d-flex align-items-center justify-content-center"><img src={iconbrios} width="80px" height="80px" /></div>
                <div className="col-sm-12 col-md-12 col-lg-5 text-lg-start text-md-center text-sm-center pt-3">
                    <h6>{data.name} Panadería</h6>
                    <p>
                        <i className="fas fa-phone"></i>
                        <strong> {data.tel} </strong>
                    </p>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 d-flex flex-column align-items-center justify-content-center">
                    {data.wtp &&
                        <button type="button" onClick={(e) => props.redirectWhatsapp(data)} className="btn btn-light appbtn2 px-4 py-3 mb-2">
                            Contactar por <img src={iconWhatsapp} alt="Contactar por whatsapp" width="30px" />
                        </button>
                    }
                    {data.tel !== "" || data.tel2 !== "" || data.tel3 !== "" ?
                        <button type="button" onClick={(e) => props.redirectLLamar(data)} className="btn btn-light appbtn3 px-4 py-3">
                            LLamar a Brios <i className="fas fa-phone"></i>
                        </button> :
                        ""
                    }

                </div>
            </li>);
        } else {
            return (<li key={i} className="row border-bottom py-3">
                <div className="col-sm-12 col-md-12 col-lg-2 d-flex align-items-center justify-content-center"><img src={minimarket} /></div>
                <div className="col-sm-12 col-md-12 col-lg-5 text-lg-start text-md-center text-sm-center pt-3">
                    <h6>{data.name}</h6>
                    <p><strong>Barrio:</strong> {data.barrio}</p>
                    <p className="mb-3"><strong>Dirección:</strong>  {data.address}</p>
                    {isExpanded && <>
                        <p>
                        {data.tel !== "" || data.tel2 !== "" || data.tel3 !== "" ? <i className="fas fa-phone"></i>: ""}
                        <strong> {data.tel} </strong>
                        <strong>{data.tel2 !== "" ? "- " + data.tel2 : ""} </strong>
                        <strong>{data.tel3 !== "" ? data.tel !== "" && data.tel2 !== "" ? data.tel3 : "- " + data.tel3 : ""} </strong>
                        </p>
                        {data.horario !== "" &&
                        <div className="mt-2 fs-6"> 
                            <p><strong>Horarios:</strong><br />
                                {data.horario}</p>
                        </div>
                        }
                        </>
                    }
                    <div className="mt-2 mb-3">
                        <a className="link-primary p-title2 border-top-1 p-2" onClick={() => handleToggle(i)} >
                            {isExpanded ? <><i className="fas fa-chevron-up"></i> Minimizar</>: <><i className="fas fa-chevron-down"></i> Más Info</>}
                        </a>
                    </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-5 d-flex flex-column align-items-center justify-content-center">
                    {data.wtp &&
                        <button type="button" onClick={(e) => props.redirectWhatsapp(data)} className="btn btn-light appbtn2 px-4 py-3 mb-2">
                            Pedir por WhatsApp <img src={iconWhatsapp} alt="hacer mi pedido por whatsapp" width="30px" />
                        </button>
                    }
                    {data.tel !== "" || data.tel2 !== "" || data.tel3 !== "" ?
                        <button type="button" onClick={(e) => props.redirectLLamar(data)} className="btn btn-light appbtn3 px-4 py-3">
                            <span className="px-3">Pedir por Teléfono</span>  <i className="fas fa-phone"></i>
                        </button> :
                        ""
                    }

                </div>
            </li>);
        }
    });

    //console.log('html',list);

    return (<ul className="p-0">{list}</ul>)
}

export default ListResult;